import { P2GLink, P2GIcon } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { FancySelection } from './FancySelection';

export const SuperLink = ({
  onClick,
  label,
  isSelected,
  icon
}: {
  onClick: () => void;
  label: string;
  isSelected: boolean;
  icon?: ReactNode;
}) => (
  <FancySelection selected={isSelected} onClick={onClick}>
    <P2GLink
      onClick={onClick}
      sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
      underline="none"
    >
      {icon && (
        <P2GIcon size="xs" palette="primary">
          {icon}
        </P2GIcon>
      )}
      {label}
    </P2GLink>
  </FancySelection>
);
